import { computed } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { settingsSections } from '../data/settingsConfig';

/**
 * Permission filtering for Settings modal sections and toolbar visibility.
 */
export function useSettingsPermissions() {
  const { isSuperAdmin, hasPermission } = useAuth();

  const isSectionAllowed = (section) => {
    if (section.availableToAll) return true;
    if (isSuperAdmin.value) return true;
    const required = section.requiredAnyPermission;
    if (!required?.length) return false;
    return required.some((code) => hasPermission(code));
  };

  const availableSections = computed(() =>
    settingsSections.filter(isSectionAllowed)
  );

  const deniedSections = computed(() =>
    settingsSections.filter((section) => !isSectionAllowed(section))
  );

  const hasAnySection = computed(() => availableSections.value.length > 0);

  const isSectionAvailable = (key) =>
    availableSections.value.some((section) => section.key === key);

  return {
    availableSections,
    deniedSections,
    hasAnySection,
    isSectionAvailable,
  };
}
